module.exports = "<img src=\"" + require("../../../../../assets/sitios/motoselpaisa/img/buscar-repuesto.jpg") + "\" class=\"img-responsive\">\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/pdf-viewer/templates/pdf-viewer-base.view.html
 ** module id = 175
 ** module chunks = 0
 **/